<template>
   <div :class="['sum-container', isActive ?'mobile_summary':'']" >
      <div class="sum-header" @click="handleSummarySelection()">Summary of your selection</div>
      <div class="sum-section-container">
         <div class="sum-error" v-if="!errorShow() && this.creds > 0 ">{{ this.error }}</div>
         <div :class="errorShow() ? 'sum-section totals success-border' : 'sum-section totals'" v-if="totalShow() && this.creds > 0">
            <div class="credits">
               Total Credits
               <div :class="errorShow() ? 'lrg-text success' : 'lrg-text error' ">{{ this.creds }}/{{ this.requiredCredits }}</div>
            </div>
            <div class="fees">
               Total Fees
               <div class="lrg-text">${{ this.totalFees }}</div>
            </div>
         </div>
         <div class="sum-section">
            <div class="sum-section-head">Your info</div>
            <div v-if="enrolmentType">
               <div class="sum-section-subhead">Enrolment type:</div>
               <div class="sum-section-content">{{ enrolmentType }}</div>
            </div>
            <div v-if="courseType">
               <div class="sum-section-subhead">Course type:</div>
               <div class="sum-section-content">{{ courseType }}</div>
            </div>
            <div v-if="feeType">
               <div class="sum-section-subhead">Fee type:</div>
               <div class="sum-section-content">{{ feeType }}</div>
            </div>
            <div v-if="commencementYear">
               <div class="sum-section-subhead">Commencement year:</div>
               <div class="sum-section-content">{{ commencementYear }}</div>
            </div>
         </div>
         <div class="sum-section" v-if="this.course">
            <div class="sum-section-head">Course</div>
               <div class="sum-section-subhead"></div>
               <div class="sum-section-content">{{this.course.code}} {{ this.course.name }}</div>
         </div>
         <div class="sum-section" v-if="this.majors.length > 0">
            <div class="sum-section-head">Major(s)</div>
            <div class="sum-section-subhead"></div>
               <div v-for="major in this.majors" :key="major.location + major.code" class="sum-section-content">{{major.code}} {{ major.name }}</div>
         </div>
         <div class="sum-section" v-if="this.comajors.length > 0">
            <div class="sum-section-head">Co-Major(s)</div>
            <div class="sum-section-subhead"></div>
               <div v-for="comajor in this.comajors" :key="comajor.location + comajor.code" class="sum-section-content">{{comajor.code}} {{ comajor.name }}</div>
         </div>
         <div class="sum-section" v-if="this.minors.length > 0">
            <div class="sum-section-head">Minor(s)</div>
            <div class="sum-section-subhead"></div>
               <div v-for="minor in this.minors" :key="minor.location + minor.code" class="sum-section-content">{{minor.code}} {{ minor.name }}</div>
         </div>
      </div>
   </div>
</template>

<script>
   import { mapGetters, mapState } from 'vuex'
   import {getFees} from 'common/models/fees.js'

   export default {
      components: {
      },
      data: function(){
         return { isActive: false }
         },
      computed: {
         ...mapGetters({
            enrolmentType: 'getEnrolmentType',
            feeType: 'getFeeType',
            courseType: 'getCourseType',
            commencementYear: 'getCommencementYear',
            error: 'getError',
         }),
         ...mapState({
            course: state => state.selections.course,
            selectedItems: state => state.selections.selectedItems,

            fees: state => !state.fee.setUpdatingFees && state.fee.fees,
         }),
         creds: function() {
            var c = 0;
            var unique = this.selectedItems.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
            for(var i=0; i<unique.length; i++){
               if(unique[i].type === "Unit"){
                  c = c + parseFloat(unique[i].credits);
               }
            }
            return c;
         },
         totalFees: function() {
            var f = 0;
            var unique = this.selectedItems.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
            for(var i=0; i<unique.length; i++){
               if(unique[i].type === "Unit" && (unique[i].unit || unique[i].fieldOfEducation)){
                  if(this.course){
                     f = f + getFees({unit: unique[i], fees: this.fees, courseCode: this.course.code, courseAbbreviation: this.course.abbreviation, log: true});
                  }else{
                     f = f + getFees({unit: unique[i], fees: this.fees, courseCode: null, courseAbbreviation: null, log: true});
                  }
               }
            }
            return Math.ceil(f);
         },
         majors: function() {
            return this.selectedItems.filter(item => item.type == "Major")
         },
         comajors: function() {
            return this.selectedItems.filter(item => item.type == "Co-Major")
         },
         minors: function() {
            return this.selectedItems.filter(item => item.type == "Minor")
         },
         requiredCredits: function(){
            if(this.course){
               return this.course.requiredCredits
            }else{
               return this.creds
            }
         }
      },
      methods: {
         errorShow(){
            if(this.creds == this.requiredCredits){
               return true;
            }else{
               return false;
            }
         },
         totalShow(){
            if(this.selectedItems.length > 0){
               return true;
            }else{
               return false;
            }
         },
         handleSummarySelection(){
            this.isActive = !this.isActive;
         }
      }
   }
</script>

